// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uikit-form__row + .uikit-form__row[data-v-10f16c60] {\n  margin-top: 20px;\n}\n.uikit-form__buttons .c-button[data-v-10f16c60] {\n  margin-left: 20px;\n}\n.uikit-form__buttons .c-button[data-v-10f16c60]:first-child {\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
